import { StyleSheet, View } from "react-native";
import { appColors, cardShadow } from "../../constants/colors";

export default function InputsOuterContainer({ children }) {
  return <View style={styles.card}>{children}</View>;
}

const styles = StyleSheet.create({
  card: {
    alignItems: "center",
    borderRadius: 16,
    width: "90%",
    backgroundColor: appColors.cardBg,
    paddingVertical: 12,
    paddingHorizontal: 14,
    borderWidth: 0.5,
    borderColor: appColors.border,
    ...cardShadow(),
  },
});
